import GET_WHOLESALE_ZONE_LIST from './getWholesaleZoneList.graphql'
export default GET_WHOLESALE_ZONE_LIST
